export default "__VITE_ASSET__CW9VXD_N__"